import React, {useState} from 'react';

import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import {Label, Legend, Line, LineChart, ResponsiveContainer, XAxis, YAxis} from "recharts";
import Tooltip from "recharts/lib/component/Tooltip";
import {makeStyles, useTheme} from '@material-ui/core/styles';
import Button from "@material-ui/core/Button";
import {ButtonBase} from "@material-ui/core";
import ButtonGroup from "@material-ui/core/ButtonGroup";

let min = false
let max = false

function createResults(selectedSolvers, data, id, timeLimit) {
    let tmp = [];
    for (let i = 0; i < selectedSolvers.length; i++)
        if (data[selectedSolvers[i].id] === undefined)
            return []
    for (let j = 0; j < selectedSolvers.length; j++) {
        let s = selectedSolvers[j];
        let result = data[s.id].filter(e => e.benchmark_id === id)[0]
        for (let b of result.bounds) {
            let time = Math.ceil(b.time)
            if (time > timeLimit)
                break;
            if (tmp[time] === undefined)
                tmp[time] = {time: time}
            tmp[time][s.name + " " + s.version] = b.bound
            if (min === false || min > b.bound)
                min = b.bound
            if (max === false || max < b.bound)
                max = b.bound
        }
    }

    let tmp2 = []
    for (let data of tmp)
        if (data !== undefined)
            tmp2.push(data)
    return tmp2;
}


export default function BoundsEvolution(props) {
    const theme = useTheme();
    const [log, setLog] = useState(false);


    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });
    min = false
    max = false
    let data = [];
    if (props.id !== -1)
        data = createResults(props.selectedSolvers, props.results, props.id, props.timeLimit)
    else
        return null;


    //if(min === 0 || max === 0 && log)
    //    setLog(false)


    /*let ticks = []

    if(log) {
        let minLog = Math.round(Math.log10(min))
        let maxLog = Math.round(Math.log10(max))
        if(minLog === maxLog)
            maxLog++
        let current = Math.pow(10, minLog);
        while (current <= Math.pow(10, maxLog)) {
            ticks.push(current)
            current *= 10
            console.log(current)
        }

        console.log(min, minLog)
        console.log(max, maxLog)
        console.log(ticks)
    }

     */
    const palette = [ "#3D91E0", "#952B60", "#F1B620", "#F952E1", "#BF4684", "#CBAE11", "#008D7C",  "#A8E10C", "#26DFE0", "#626520"]
    const shapes = ["dot", "cross", "diamond", "rectangle", "polygon"]
    const Square = function(props) {
        const { cx, cy, stroke, payload, value } = props;
        return (
                <rect x={cx - 3} y={cy - 3}  fill='transparent' stroke={stroke} width={6} height={6}></rect>

        )
    }


    const myStyles = makeStyles({
        icon: {
            position: "absolute",
            right: "10"
        },
        tooltip: {
            padding : "10px",
            zIndex: 10,
            border: "1px solid lightgrey",
            backgroundColor: "white",

        },
        solver : {
            padding: "2px 10px",
            display: "flex",
            justifyContent: "space-between"


        },
        span2 : {
            marginRight : "5px",
        }
    });

    function CustomTooltip(props) {
        //if(props.payload.length > 1) console.log(props)
        if (props.active === false)
            return null
        const classes2 = myStyles();

        let payload  = props.payload
        payload.sort((a, b) => a.value - b.value)

        return (
            <div className={classes2.tooltip}>
                At time {props.label}s:
                {payload.map( p => <div className={classes2.solver} style={{color: p.stroke}}><span className={classes2.span2}>{p.name}:</span> <span>{p.value}</span></div>)}
            </div>
        )
    }


    return (
        <Dialog onClose={props.handleClose} aria-labelledby="customized-dialog-title" open={props.open} fullWidth={true} maxWidth={"lg"}>
            <DialogTitle id="customized-dialog-title" onClose={props.handleClose}>
                {props.benchmark[0].name}
                <IconButton style={{float: "right", marginTop: "-5px"}} aria-label="close" onClick={props.handleClose}>
                    <CloseIcon/>
                </IconButton>
                {/*<ButtonGroup color="primary" style={{float: "right"}}>
                    <Button variant='contained' color="primary" onClick={e => setLog(!log)}>
                        {!log ? "Log" : "Lin"}
                    </Button>
                </ButtonGroup>*/}

            </DialogTitle>
            <DialogContent>
                <ResponsiveContainer width={'100%'} height={400}>

                    <LineChart data={data} margin={{ top: 5, right: 0, left: 50, bottom: 5  }}>
                        <Legend verticalAlign="top" />
                        <XAxis dataKey="time" stroke={theme.palette.text.secondary} type="number" allowDataOverflow={true}>
                            <Label position="insideBottom">Time</Label>
                        </XAxis>
                        <YAxis stroke={theme.palette.text.secondary} domain={[min, max]} scale={log ? "log" : "linear"} tickMargin='0'>
                            <Label  position="top"   style={{textAnchor: 'middle', fill: theme.palette.text.primary}}>Bound</Label>
                        </YAxis>
                        <Tooltip content={<CustomTooltip />}/>
                        {props.selectedSolvers.map((s, i) => <Line connectNulls key={'l' + s.id} type="monotone" dataKey={s.name + " " + s.version}
                                                                   stroke={palette[i % palette.length]} shape={shapes[i % shapes.length]}

                                                                   />)}
                    </LineChart>
                </ResponsiveContainer>
            </DialogContent>
        </Dialog>
    );
}
